import { FilterOutlined } from '@ant-design/icons';
import { Table, Row, Col, Typography, Pagination, Input, Space, Popover, Radio, Button } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import { ColumnsType } from 'antd/lib/table';
import { format } from 'date-fns';
import React from 'react';

import { GachaRegister } from '@/api-client/generated/models';
import '@/GachaRegister/styles/gachaRegisterTable.css';

type GachaRegisterTableProps = {
  gachaRegisters: GachaRegister[];
  gachaRegistersNum: number;
  currentPage: number;
  perPage: number;
  onChangeCurrentPage: (newPage: number) => void;
  onChangeOs: (os: string) => void;
  onSearch: (word: string) => void;
};

type TableHeaderProps = {
  totalNum: number;
  onSearch: (word: string) => void;
};

type OsHeaderProps = {
  // eslint-disable-next-line react/require-default-props
  onChangeOsRadio?: (e: RadioChangeEvent) => void;
};

const dateFormat = 'yyyy/MM/dd HH:mm:ss';

const OsHeader: React.FC<OsHeaderProps> = ({ onChangeOsRadio }) => {
  const content = (
    <Radio.Group className="os-select" onChange={onChangeOsRadio} defaultValue="">
      <Radio value="" className="os-select-el">
        全てのOS
      </Radio>
      <Radio value="ios" className="os-select-el">
        iOS
      </Radio>
      <Radio value="android" className="os-select-el">
        Android
      </Radio>
    </Radio.Group>
  );
  return (
    <Space>
      OS
      <Popover content={content} trigger="focus" placement="bottom">
        <Button type="text">
          <FilterOutlined />
        </Button>
      </Popover>
    </Space>
  );
};

const TableHeader: React.FC<TableHeaderProps> = ({ totalNum, onSearch }) => (
  <Row>
    <Col span={2}>
      <Typography.Title level={5}>総数: {totalNum || 0}</Typography.Title>
    </Col>
    <Col span={6}>
      <Input.Search placeholder="フリーワード検索" onSearch={onSearch} />
    </Col>
  </Row>
);

const GachaRegisterTable: React.FC<GachaRegisterTableProps> = ({
  gachaRegisters,
  gachaRegistersNum,
  currentPage,
  perPage,
  onChangeCurrentPage,
  onChangeOs,
  onSearch,
}) => {
  const onChangeOsRadio = (e: RadioChangeEvent) => {
    onChangeOs(e.target.value);
  };

  const onChangeCurrentPagePagination = (page: number) => {
    onChangeCurrentPage(page);
  };

  const columns: ColumnsType = [
    {
      title: 'ユーザ名',
      dataIndex: ['user', 'nickname'],
      key: 'username',
    },
    {
      title: 'メールアドレス',
      dataIndex: ['user', 'mailAddress'],
      key: 'mailAddress',
    },
    {
      title: OsHeader({ onChangeOsRadio }),
      dataIndex: 'os',
      key: 'os',
    },
    {
      title: '登録日',
      key: 'createdAt',
      render: (_: any, row: GachaRegister) => format(row.createdAt, dateFormat),
    },
  ];

  return (
    <div className="gacha-register-table">
      <Table
        columns={columns}
        dataSource={gachaRegisters}
        rowKey={(gachaRegister: GachaRegister) => gachaRegister.id}
        pagination={false}
        title={() => TableHeader({ totalNum: gachaRegistersNum, onSearch })}
      />
      <Pagination
        simple
        current={currentPage}
        pageSize={perPage}
        total={gachaRegistersNum}
        onChange={onChangeCurrentPagePagination}
      />
    </div>
  );
};

export default GachaRegisterTable;
